import { configurePaymentComponent } from '../payment-panel/payment-orchestrator';
import { ComponentConfig, ComponentName } from '../types/external/component';
import { PaymentComponentConfig, PaymentComponentInstance } from '../types/external/payment-component';
import { getFerootConfig, injectFerootScript } from '../utils/feroot-injector';
import { logger } from './logger';

/**
 * Main ESW Components SDK class that serves as the entry point for the API
 */
export class ESWComponents {
  constructor(globalConfig: ComponentConfig) {
    logger.info('ESWComponents initialized with', globalConfig);
    this.globalConfig = globalConfig;
  }

  private readonly globalConfig: ComponentConfig;

  create(name: ComponentName, config: PaymentComponentConfig): PaymentComponentInstance {
    if (!name) {
      logger.error('Components name is required');
    }

    if (name === 'payment-panel') {
      injectFerootScript(getFerootConfig());

      const mergedConfig: PaymentComponentConfig = {
        ...this.globalConfig,
        ...config
      };

      return configurePaymentComponent(mergedConfig);
    } else {
      throw new Error(`Component ${name} is not supported`);
    }
  }
}
